import { getProfileExperience } from "@/utils";
import { useEffect, useState } from "react";

import { getPersonalDetails } from "@/components/profile/contactCard/query";
import { getPreference } from "@/components/profile/preferencesCard/query";
import { getSkills } from "@/components/profile/skills/query";

import DfpSlot from "./DfpSlot";

type profileDataType = {
  profileSkills: string[];
  profileLoc: string[];
  profileExp: string[];
  profileFunc: string[];
  profileInd: string[];
};

const ExternalAd = ({
  adName,
  adSize,
  additionalClass,
  isBBSlot = true,
  isLoggedIn = false,
  adPageName = "",
}: {
  adName: string;
  adSize?: number[];
  additionalClass?: string;
  isBBSlot?: boolean;
  isLoggedIn?: boolean;
  adPageName?: string;
}) => {
  const { data: userInfo } = getPersonalDetails();
  const { data: userSkills } = getSkills();
  const { data: userPreference = null } = getPreference();

  const defaultSize = adSize
    ? ["fluid", [1, 1], adSize]
    : ["fluid", "Custom rendering", [1, 1], [600, 250], [750, 200], [800, 250]];
  const [profileData, setProfileData] = useState<profileDataType | null>(null);

  let getProfileData = () => {
    const hasProfileData = userInfo
      ? Object.values(userInfo).every(
          (value) => value === null || value === undefined,
        )
      : false;

    if (hasProfileData) {
      setProfileData(null);
      return;
    }

    const profileData = {
      profileSkills: userSkills?.skillSection?.skills
        ? userSkills?.skillSection?.skills.map(
            (skills: { skill: { text: string } }) => skills?.skill?.text ?? "",
          )
        : [""],
      profileExp: userInfo?.personalDetailSection?.personalDetails
        ? [
            getProfileExperience(
              userInfo?.personalDetailSection?.personalDetails
                ?.additionalPersonalDetail?.experience?.years ?? 0,
              userInfo?.personalDetailSection?.personalDetails
                ?.additionalPersonalDetail?.experience?.months ?? 0,
            ),
          ]
        : [""],

      profileLoc: Array.from(
        new Set([
          userInfo?.personalDetailSection?.personalDetails
            ?.additionalPersonalDetail?.currentLocation?.text ?? "",
          ...(userPreference?.jobPreferenceSection?.jobPreference?.locations?.map(
            (loc: any) => loc.text,
          ) ?? [""]),
        ]),
      ),

      // Talked with Anil regarding this
      // further solution is needed
      // passing empty array for now
      profileFunc: [""],
      profileInd: [""],
    };
    setProfileData(profileData);
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <div className={`flex justify-center ${additionalClass}`}>
      {isLoggedIn && profileData ? (
        <DfpSlot
          adUnit="/22246878517/Web-MonsterAPAC"
          name={adName}
          size={defaultSize}
          isBBSlot={isBBSlot}
          isLoggedIn={isLoggedIn}
          profileData={profileData}
          adPageName={adPageName}
        ></DfpSlot>
      ) : null}
    </div>
  );
};

export default ExternalAd;
